<template>
  <div
    :class="[
      'auth-labeled-link flex-row align-center gap-1',
      `justify-${justify}`,
    ]"
  >
    <OwnType v-if="label" :text="label" variant="paragraph-small" />
    <OwnType
      v-if="isExternalLink"
      class="auth-labeled-link__anchor"
      :href="link"
      :text="linkText"
      el="a"
      variant="paragraph-small"
      color="brand"
    />
    <router-link v-else :to="link">
      <OwnType
        class="auth-labeled-link__anchor"
        :text="linkText"
        variant="paragraph-small"
        color="brand"
      />
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { type RouteLocationRaw } from 'vue-router'

import { OwnType } from '@/ui/OwnType'

const props = withDefaults(
  defineProps<{
    justify?: 'center' | 'start' | 'end'
    label?: string
    link: RouteLocationRaw
    linkText: string
  }>(),
  {
    justify: 'center',
    label: undefined,
  }
)

const isExternalLink = computed(() => {
  return typeof props.link === 'string'
})
</script>

<style lang="scss" scoped>
.auth-labeled-link {
  // Have to override the v-application color until we remove vuetify
  &__anchor {
    color: var(--misc-brand);
  }
}
</style>
